<template>
  <div class="adstats">
    <h2 class='title is-4'>Ad server stats</h2>
    <graph-bar width="100%" :height="400" :colors="bar_colours" :axis-min="0" :axis-max="axis_max" :labels="labels" :values="values" :barMargin=5>
      <note :text="chart_title"></note>
      <tooltip :names="names" :position="'left'"></tooltip>
      <legends :names="names" :filter="true"></legends>
    </graph-bar>
    <table class='table is-bordered is-striped is-hoverable is-fullwidth'>
      <thead>
        <tr>
          <th></th>
          <th class='c' v-for="(d, idx) in labels" v-bind:key="idx">{{ d }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(n, idx) in names" v-bind:key="idx">
          <th><router-link v-bind:loctitle="n" v-bind:to="`/adstats/`+expandLocation(n, true)">{{ n }}</router-link></th>
          <td v-for="(v, i) in values[idx]" v-bind:key="i">{{ v }}</td>
        </tr>
      </tbody>
    </table>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name : 'adstats',
  data : function(){
    return {
      stats : {},
      labels : [], // dates
      names: [], // locations
      axis_max : 0,
      values: [],
      bar_colours : ['#7BBAE7','#FFC000'],
      chart_title : 'Last seven days'
    }
  },
  mounted(){
    this.getData();
  },
  methods : {
    getData : function(){
      this.callAPI('get', 'adstats')
        .then((res) => {
          this.processStats(res.data.stats);
        })
        .catch((err) => { console.error(err); });
    },
    processStats : function(stats){
      let labels = [];
      let max_axis = 0;
      let locations = {};
      stats.forEach((s) => {
        if(!locations.hasOwnProperty(s.location)){
          locations[s.location] = {};
        }
        locations[s.location][this.formatDate(s.ymd)] = s.total_hits;
      });
      this.stats = locations;
      for(let loc in locations){
        this.names.push(this.expandLocation(loc));
        let loc_hits = [];
        for(let ymd in locations[loc]){
          labels.push(ymd);
          let hits = parseInt(locations[loc][ymd], 10);
          if(hits > max_axis){ max_axis = hits; }
          loc_hits.push(hits);
        }
        this.values.push(loc_hits);
      }
      this.max_axis = max_axis + 10;
      this.labels = [...new Set(labels)];
      // console.log(this.stats);
    },
    formatDate : function(d){
      return `${d.slice(0,4)}-${d.slice(4,6)}-${d.slice(6)}`;
    },
    expandLocation : function(loc, getcode){
      let locs = {
        'sr' : 'SailRacer',
        'yy' : 'Yachts and Yachting'
      };
      return (getcode ? Object.keys(locs).find(key => locs[key] === loc) : locs[loc]);
    }
  }
};
</script>